<style>
  .body {
    background-color: white !important
  }

  #bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -5000;

  }
</style>
<div style="position:absolute; bottom:10px;right:20px;text-align:right;padding:10px;color: gray;">Version 03.02.01</div> 
<div><img src="/assets/images/background.jpg" id="bg"></div><div class="page-wrap height-100">  <div class="session-form-hold">
     
    <mat-card style="background-color:white;">

      <mat-card-content  >
           
          <div [hidden]="Loading"> 
        <div class="text-center pb-1">
          <!-- <img src="/assets/images/logo3.png" alt="" class="mb-05"> -->
          <img [src]="logoUrl" alt="" class="mb-05">
          <!-- <p class="text-muted m-0">Sign in to your account</p> -->
        </div>
      
        <small *ngIf="returnValues.error" class="form-error-msg">{{returnValues.message}} </small>
        <!-- <form #signinForm="ngForm" (ngSubmit)="signin()" >
          <div class="">
            <mat-form-field class="full-width">
              <input matInput name="username" required [(ngModel)]="signinData.username" #username="ngModel" placeholder="Username" value="">
            </mat-form-field>
            <small *ngIf="username.errors && (username.dirty || username.touched) && (username.errors.required)" class="form-error-msg"> Username is required </small>
          </div>

          <div class="">
            <mat-form-field class="full-width">
              <input type="password" name="password" required matInput [(ngModel)]="signinData.password" #password="ngModel" placeholder="Password"
                value="">
            </mat-form-field>
            <small *ngIf="password.errors && (password.dirty || password.touched) && (password.errors.required)" class="form-error-msg"> Password is required </small>
          </div>

          <div class="pb-1">
            <mat-checkbox [(ngModel)]="signinData.rememberMe" name="rememberMe" class="pb-1">Remember this computer</mat-checkbox>
          </div>

          <button mat-raised-button class="mat-primary full-width mb-1" [disabled]="signinForm.invalid">Sign in</button>

          <div class="text-center">
            <a [routerLink]="['/sessions/forgot-password']" class="mat-primary text-center full-width">Forgot password</a>
            <span fxFlex></span>
            <a [routerLink]="['/sessions/signup']" class="mat-primary text-center full-width">Create a new account</a>
          </div>
        </form> -->
        <!-- <button mat-raised-button class="mat-primary full-width mb-1" (click)="login()">Sign in</button> -->
        
        <button mat-raised-button class="mat-primary full-width mb-1" (click)="oauth2SignIn()">Sign in</button>
       
       
       
      
      </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div style="font-size: 10pt;font-weight: lighter;color:gray;text-decoration: underline;"
     (click)="oauth2SignIn(true)">...</div>

       
</div>